import * as React from "react";

function ChevronsLeftIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    role: "img",
    fill: "currentColor",
    className: "anticon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m73.22 256 160.1-167.4c9.125-9.594 8.844-24.78-.75-33.94s-24.77-8.82-33.87.74l-176 184c-8.875 9.313-8.875 23.88 0 33.19l176 184c9.156 9.563 24.34 9.907 33.94.75C237.5 452.6 240 446.3 240 440c0-5.969-2.219-11.94-6.656-16.59L73.22 256zM425.3 423.4 265.2 256 425.3 88.6c9.125-9.594 8.844-24.78-.75-33.94s-24.78-8.813-33.94.75l-176 184c-8.875 9.313-8.875 23.88 0 33.19l176 184c9.156 9.563 24.34 9.907 33.94.75C429.5 452.6 432 446.3 432 440c0-6-2.2-11.9-6.7-16.6z"
  }));
}

const ForwardRef = React.forwardRef(ChevronsLeftIcon);
export default ForwardRef;